import { Box, Button, Grid, Link, Typography } from '@material-ui/core'
import ViewWrapper from 'components/ViewWrapper'
//import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import TestIDs from 'utils/TestIDs'
import { getHeader, navigationLinks } from 'utils/utils'

const NewSepa = (): JSX.Element => {
    const history = useHistory()
    const { t } = useTranslation()
    //const anchorRef = useRef<HTMLAnchorElement>(null)
    // const handleSubmit = () => {
    //     if (anchorRef.current !== null) {
    //         //DOWNLOAD pdf
    //         anchorRef.current.click()
    //     }
    // }
    return (
        <ViewWrapper
            header={getHeader(`/${t('url.dashboard')}`, history, t, [])}
            navigation={navigationLinks('logged-in', 'myData', t)}
        >
            <>
                <Box marginBottom={5}>
                    <Typography variant={'h2'}>{t('pages.newSEPA.title')}</Typography>
                </Box>

                <Grid item xs={12}>
                    <Typography variant={'body1'} style={{ fontWeight: 800 }}>
                        {t('pages.newSEPA.addrPost')}
                    </Typography>
                    <Typography variant={'body1'}>Stadtwerke Leipzig GmbH</Typography>
                    <Typography variant={'body1'}>Augustusplatz 7</Typography>
                    <Typography variant={'body1'}>04109 Leipzig</Typography>

                    <Typography variant={'body1'} style={{ paddingTop: 20, fontWeight: 800 }}>
                        {t('pages.newSEPA.addrEmail')}
                    </Typography>
                    <Typography variant={'body1'}>
                        <Link color={'inherit'} href={'mailto:glasfaser.stadtwerke@l.de'}>
                            glasfaser.stadtwerke@l.de
                        </Link>
                    </Typography>
                    <Typography variant={'body1'} style={{ paddingTop: 20 }}>
                        Sie können Ihr SEPA-Mandat jederzeit ändern. Senden Sie dazu eine E-Mail an
                    </Typography>
                    <Typography variant={'body1'}>
                        <Link color={'inherit'} href={'mailto:glasfaser.stadtwerke@l.de'}>
                            glasfaser.stadtwerke@l.de
                        </Link>
                    </Typography>
                </Grid>

                <Box
                    marginTop={5}
                    marginBottom={5}
                    display={'flex'}
                    flexDirection={{ xs: 'column', md: 'row' }}
                    justifyContent={'space-between'}
                >
                    <Button
                        variant={'outlined'}
                        color={'default'}
                        {...TestIDs.GET_NEW_SEPA('CANCEL_BUTTON')}
                        onClick={() => history.goBack()}
                    >
                        {t('general.back')}
                    </Button>

                    {/* <Button
                        variant={'contained'}
                        color={'primary'}
                        {...TestIDs.GET_NEW_SEPA('SUBMIT_BUTTON')}
                        onClick={handleSubmit}
                    >
                        <a
                            style={{
                                pointerEvents: 'none',
                                textDecoration: 'none !important',
                                color: '#032c58',
                            }}
                            ref={anchorRef}
                            role="button"
                            href="mockPDF.pdf"
                            download="sepa.pdf"
                        >
                            {t('pages.newSEPA.savePDF')}
                        </a>
                    </Button> */}
                </Box>
            </>
        </ViewWrapper>
    )
}

export default NewSepa
